<cfp-report-cover-page
  [portfolioId]="portfolioId()"
  [reportTitle]="reportTitle()"
  [organizationName]="organizationName()"
  [customLogo]="customLogo()"
  [logo]="logo()"
  [coverPageClasses]="coverPageClasses()"
/>

<cfp-printable-content>
  <ng-container body>
    <ng-content />
  </ng-container>

  <cfp-report-footer footer>
    {{ organizationName() }} -
    @if (organizationId()) {
      {{ organizationId() }} -
    }
    {{ currentDate | date: 'longDate' }}
  </cfp-report-footer>
</cfp-printable-content>
